import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import metricsService, {FAILED, UPLOAD_PREVIEW, SUCCEEDED} from 'src/services/metrics/metrics.service';
import biLoggingService, {ErrorReportData, SeverityType} from 'src/services/bi-logging/bi-logging.service';

const errorMessage = 'Download Webview file is failed.'
export const getWebviewFileAsync = createAsyncThunk(
    'webview/getFile',
    async (url: string, thunkAPI) => {
        try {
            metricsService.setDimensionInfo(UPLOAD_PREVIEW);
            const response = await axios.get(url, {
                responseType: 'arraybuffer',
            });
            metricsService.sendMetrics(UPLOAD_PREVIEW, SUCCEEDED);
            return response.data;
        } catch (e) {
            metricsService.sendMetrics(UPLOAD_PREVIEW, FAILED);
            const errorData: ErrorReportData = {
                object: errorMessage,
                code: '',
                description: errorMessage,
                severity: SeverityType.Error
            }
            biLoggingService.sendErrorReport(errorData);
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);
